import { useCallback, useState } from 'react';

import { Card } from '@mui/material';

import { useGetAllAccountsQuery } from 'src/services/admin/admin.service';
import { PageOptions } from 'src/services/api.types';

import GlobalAccountsTable from './global-accounts-table';

const default_page: PageOptions = {
  page: 1,
  per_page: 20
};

export default function GlobalAccountsTableView() {
  const [pageOptions, setPageOptions] = useState<PageOptions>(default_page);

  const [filters, setFilters] = useState<{ search_query?: string, online_only?: boolean }>({});

  const { currentData, isLoading } = useGetAllAccountsQuery({
    ...pageOptions,
    search_query: filters?.search_query || '',
    online_only: filters?.online_only || false,
  });

  const onChangePage = (_event: any, pageNumber: number) => {
    setPageOptions((prev) => ({ ...prev, page: pageNumber + 1 }));
  };

  const onChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setPageOptions((prev) => ({ ...prev, per_page: parseInt(event.target.value, 10) }));
  };

  const onChangeFilters = useCallback((name: string, value: any) => {
    setFilters((prev) => ({
      ...prev,
      [name]: value,
    }));

    setPageOptions((prev) => ({ ...prev, page: 1 }));
  }, []);

  return (
    <Card>
      <GlobalAccountsTable
        isLoading={isLoading}
        accounts={currentData}
        onChangePage={onChangePage}
        onChangeRowsPerPage={onChangeRowsPerPage}
        currentPage={pageOptions}
        filters={filters}
        onFilter={onChangeFilters}
      />
    </Card>
  );
}